var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdvantageIcon3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 32,
    viewBox: "0 0 40 32",
    width: 40,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m14.8 24.1 5.2-4.05 5.2 4.05-2-6.4 4.9-4.1h-6l-2.1-6.1-2.1 6.1h-6l4.9 4.1zm-11.8 7.9c-.83333 0-1.54167-.2917-2.125-.875-.583333-.5833-.875-1.2917-.875-2.125v-6.6c0-.3333.0916667-.625.275-.875.183333-.25.425-.425.725-.525 1.03333-.3667 1.84167-1.025 2.425-1.975s.875-1.9583.875-3.025c0-1.0333-.29167-2.0333-.875-3s-1.39167-1.6333-2.425-2c-.3-.1-.541667-.275-.725-.525-.1833333-.25-.275-.54167-.275-.875v-6.6c0-.83333.291667-1.54167.875-2.125.58333-.583333 1.29167-.875 2.125-.875h34c.8333 0 1.5417.291667 2.125.875.5833.58333.875 1.29167.875 2.125v6.6c0 .33333-.0917.625-.275.875s-.425.425-.725.525c-1.0333.3667-1.8417 1.0333-2.425 2s-.875 1.9667-.875 3c0 1.0667.2917 2.075.875 3.025s1.3917 1.6083 2.425 1.975c.3.1.5417.275.725.525s.275.5417.275.875v6.6c0 .8333-.2917 1.5417-.875 2.125s-1.2917.875-2.125.875zm0-3h34v-5.45c-1.2667-.8667-2.3-1.95-3.1-3.25s-1.2-2.7333-1.2-4.3.4-3 1.2-4.3 1.8333-2.38333 3.1-3.25v-5.45h-34v5.45c1.3.86667 2.34167 1.95 3.125 3.25s1.175 2.7333 1.175 4.3-.39167 3-1.175 4.3-1.825 2.3833-3.125 3.25z",
    fill: "#fcc241"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdvantageIcon3);
export default __webpack_public_path__ + "static/media/advantage-icon-3.303c05e0e60588ad90a283ccd1bd4cfc.svg";
export { ForwardRef as ReactComponent };